<template>
    <m-pageframe
        title="Shipping Events Held in Abeyance"
    >
    <v-container
        fluid
    >
    
        <v-text-field
            autocomplete="off"
            label="Search"
            prepend-icon="mdi-magnify"
            v-model="search"
            append-icon="mdi-refresh"
            v-on:click:append="doUpdate"
        >
        </v-text-field>
    
        <v-data-table
            v-if="results != null"
            :headers="headers"
            :items="results"
            :items-per-page="50"
            class="elevation-1"
            :search="search"
            disable-sort
            :footer-props="{
                itemsPerPageOptions: [25, 50, 100, -1],
            }"
        >

            <template v-slot:item.content_type="{ item }">
                {{ $rc.pretty(item.content_type, 'integration_name') }}
            </template>
    
            <template v-slot:item.endpoint="{ item }">
                {{ item.endpoint ? $rc.pretty(item.endpoint, 'endpoint') : item.endpoint }}
            </template>
    
    
            <template v-slot:item.action="{ item }">
                <v-menu
                    v-if="item.first_in_batch"
                    bottom 
                    offset-y  
                >
                    <template v-slot:activator="{ on }">
                        <v-icon 
                            v-on="on"
                        >
                            mdi-dots-vertical-circle-outline
                        </v-icon>
                    </template>
    
                    <v-list>
                        <v-list-item
                            v-on:click="onClickViewChunkDetail(item)"
                        >
                            <v-list-item-title>View chunk detail...</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu> 
            </template>
    
        </v-data-table>
    
    </v-container>
    </m-pageframe>
    </template>
    
    <script>
    const _ = require('lodash');
    export default {
        data() {
            return {
                search: '',
                results: [],
            }
        },
    
        mounted () {
            this.doUpdate();
        },
    
        methods: {
            update: _.debounce(function(){
                this.doUpdate();
            }, 751),
            
            doUpdate()
            {
                this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'LIST: /api/v1/shipping/:organization_id/abeyance',
                
                    'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
                
                    'on_success': (data) => {
                            this.results = data.results;
                        },
                
                    'on_error': 'Unable to list shipping events held in abeyance',
                });
            },
    
        },
    
        computed: {
            headers()
            {
                let ret = [];

                ret.push({ text: 'Triggered By', value: 'content_type'});
                ret.push({ text: 'Abeyance Date', value: 'abeyance_date'});
                ret.push({ text: 'Tracking No', value: 'tracking_number'});
                ret.push({ text: 'First Name', value: 'first_name'});
                ret.push({ text: 'Last Name', value: 'last_name'});
                ret.push({ text: 'Phone', value: 'endpoint'});

                return ret;
            },
        }
    }
    </script>
    
    <style lang="scss" scoped>
    </style>